<template>
  <div>
      <div>
        <div class="agreement-container">
          <h2 class="title">众筹服务协议</h2>
          <p style="float: right">生效日期：2023年5月1日</p>
          <p>&nbsp;</p>
          <p class="p-text">本协议已对与您（指拟使用e农农服县域服务商平台（以下称“平台”）发起众筹项目的用户）的权益有或可能具有重大关系的条款，及e农农服平台的运营、管理主体华农农服（北京）网络科技有限公司（以下称“我们”）具有或可能具有免责或限制责任的条款予以标注。 如果您对本协议的条款有疑问的，请通过我们服务渠道进行询问，我们将向您解释条款内容。在您接受本协议约定由我们提供的服务时（以下称“本服务”）时，您已充分阅读、理解并接受本协议的全部内容（特别是以粗体标注的内容），一旦您使用本服务，即表示您同意遵循本协议之所有约定。</p>
          <p class="bold">1. 定义和解释</p>
          <p>1）众筹：指发起人与支持者共同完成项目的行为,在这一过程中支持者出资支持发起人在平台发起的众筹项目，发起人完成项目并按承诺向支持者发放众筹产品。</p>
          <p>2）众筹项目：指发起人依据我们于平台发布的众筹规则的要求，通过平台发布相应项目的众筹需求并按要求募集资金，并依据我们发布的众筹规则进行收款及发货的产品经营活动。</p>
          <p>3）众筹产品：指发起人拟筹款完成的众筹项目面向支持者的众筹回报，即发起人生产、销售、配送的实物产品，本协议中称为“众筹产品”或“产品”。</p>
          <p>4）众筹资金：指发起人发布众筹项目后，自众筹项目支持者处获得的支持资金，可指发起人自支持者处获得的一笔或多笔支持资金。在众筹成功后，该资金将按照众筹规则的要求支付给发起人，在该资金支付给发起人前，发起人不具有对该资金的所有权及使用权。</p>
          <p>5）众筹规则：指平台发布的关于众筹、众筹项目等的各项规则、规范及其他法律文件的统称。</p>
          <p>6）发起人：指在平台上发起项目的自然人、法人或其他组织，本协议中可称为“您”。发起人于平台依法开展经营活动，独立进行订单处理、物流配送、售后服务，对其在平台的经营活动独立承担法律责任。</p>
          <p>7）支持者：指对发起人的项目表示支持的我们用户。支持者通过支付一定金额众筹支持款项的方式，支持发起人在平台发起的众筹项目，并按照与发起人的约定取得众筹项目的项目成果及/或相关产品。</p>
          <p>8）关联公司/机构：指与某一自然人、法人、非法人组织存在股权、控制权、管理权等层面的关联关系的法人或非法人组织。</p>
          <p>9）众筹期限：指发起人对外公布的众筹项目募集款项的时间。</p>
          <p>10）募集总金额：指众筹期限届满时，发起人发起的众筹项目所募集的款项总额。</p>
          <p>11）众筹成功：指在发起人设定的众筹期限内，募集总金额达到或超过了发起人设定的目标筹款金额。</p>
          <p>12）众筹期间：指从自众筹项目上线之日起至所有支持者均确认收货之日止的一段时间，包括发起人发起众筹项目、支持者支持众筹项目、发起人生产、发货及所有支持者确认收货完成等行为及活动的一个完整周期。</p>
          <p>13）项目名称：指众筹活动的标题名称。</p>
          <p>14）项目描述：指众筹活动的内容描述、介绍等。</p>
          <p>15）上线时间：指发起人确认众筹活动发布日期。</p>
          <p>16）筹款天数：指众筹活动时长，最长设定不超过45天。</p>
          <p>17）目标金额：指众筹活动目标金额不能低于1000元，不能高于5000000元。</p>
          <p>18）首付款占比： 指筹款成功时，发起人可以收到的首付款为货款的%。首付款占比设置不超过10%。</p>
          <p>19）支持者确认合同/文本时间：指发起者上传合同/文本后，支持者确认同意/拒绝时间，系统默认为3天或设置不超过3天，3天内或设置天数内未确认默认为不同意。支持者确认同意数量达到支持者总量的70%后则活动继续。</p>
          <p>20）服务费：指发起者所收取支持者的服务费用。设置范围为大于1%，小于5%。</p>
          <p>21）最晚发货期：指众筹活动成功后最晚可以发货日期。</p>
          <p>&nbsp;&nbsp;&nbsp; a) 众筹活动成功后，用户接受众筹结果、商品合同或其它文本后，需在最晚发货期之前，支付尾款，如未支付，则用户为违约，订单不能进行退款。
          <p>&nbsp;&nbsp;&nbsp; b) 众筹活动成功后，用户不接受众筹结果、商品合同或其它文本，订单可申请退款，系统处理后会在3个工作日内原路退回。
          <p>&nbsp;&nbsp;&nbsp; c) 如发起人实际发货日期超过设定的最晚发货期，需发起人独立承担相应违约责任。</p>
          <p class="bold">2. 签约主体和效力范围</p>
          <p>1）为了规范发起人使用平台的各项行为，明确发起人及平台的权利义务，保障您和支持者的合法权益，特拟定本协议，本协议由作为发起人的您与我们共同签署。</p>
          <p>2）<span class="p-text">您通过网络页面点击确认或以其他方式选择接受本协议，即表示您与我们已达成协议并同意接受本协议的全部约定内容。本协议自您通过网络页面点击确认或以其他方式选择接受本协议之时起生效。</span></p>
          <p>3）<span class="p-text">我们可不时修改本协议及相关规则，如本协议及相关规则有任何变更，我们将在平台上以公示形式通知。公示时间（以下称“公示期”）将不少于7日。在公示期内，您可通过平台中公布的联系方式向我们反馈您对修改内容的意见及建议，我们将充分考虑。修改后的协议及规则将自公示期满之日的次日生效并实施，并成为本协议的补充协议或替代本协议发生效力。如您继续登录或使用平台的，即视为您已阅读并接受修改后的协议及规则。</span></p>
          <p class="bold">3. 平台服务</p>
          <p>1）我们会对您发起的众筹项目的合理性、众筹项目内容等进行形式审核，审核通过并经过您确认后您才可发布到平台，但<span class="p-text">您发起的众筹项目通过我们的审核并不代表我们保证您的众筹项目合法、真实、准确或不侵犯任何第三方的权利，您仍需对您发起的众筹项目独立承担法律责任，我们亦无义务监督众筹项目的执行与实现。</span></p>
          <p>2）发起人发起并通过我们审核最终自主发布到平台的众筹项目，可由其他发起人、支持者、众筹平台的其他使用者浏览、关注、分享、参与、支持等。通过平台，发起人可以从支持者处筹集到众筹资金，利用众筹资金完成众筹项目中承诺的众筹产品的设计、生产、委托采购后，向支持者交付众筹产品。</p>
          <p class="bold">4. 发起人行为规范</p>
          <p>1）您了解并同意，您不得从事任何违反法律法规或侵犯任何第三方权利的行为，包括但不限于不得自行或允许任何第三方使用您的账号通过平台从事与下述相关的行为或发布与下述相关的信息：</p>
          <p>&nbsp;&nbsp;&nbsp;a) 违反任何法律法规，或侵犯任何主体的专利、商标、著作权、商业秘密或其他合法权利的；</p>
          <p>&nbsp;&nbsp;&nbsp;b) 虚假的、误导性的、不准确的； </p>
          <p>&nbsp;&nbsp;&nbsp;c) 涉嫌非法、威胁、辱骂、骚扰、诽谤、中伤、欺骗、欺诈、侵权、淫秽、冒犯、亵渎或侵犯他人隐私的；</p>
          <p>&nbsp;&nbsp;&nbsp;d) 未经接收方允许而向接收方发布任何邮件、宣传材料或广告信息；</p>
          <p>&nbsp;&nbsp;&nbsp;e) 进行任何危害信息网络安全的行为，故意传播恶意程序或病毒以及其他破坏、干扰正常网络信息服务的行为。</p>
          <p>2）<span class="p-text">您需如实描述众筹项目及众筹资金使用方式并如实使用众筹资金，否则众筹项目支持者可追究您的违约责任，构成犯罪的，支持者可要求司法机关依法追究您刑事责任，您理解我们将配合司法机关提供您及众筹项目的相关信息。</span></p>
          <p>3）<span class="p-text">在众筹期间，除我们书面盖章同意外，您不得自行或委托其他任何第三方平台发布众筹项目的众筹或预售。</span></p>
          <p>4）<span class="p-text">如众筹项目众筹成功后，因任何主观因素或客观因素而将发生众筹项目延期或众筹项目最终无法完成的情形，您应及时通过平台及其他途径告知支持者。</span></p>
          <p>5）<span class="p-text">众筹项目众筹成功后，对于不可归因于支持者责任（包括但不限于商品内容不符、商品内容存在产品质量问题等）的交易纠纷，在支持者申请全额退款的情况下，您应将支持者支付的款项全额退回给支持者。</span></p>
          <p>6）<span class="p-text">我们有权对您是否涉嫌违反上述使用规范做出认定，并根据认定结果中止、终止您对平台及我们提供的服务的使用或采取其他限制措施。</span></p>
          <p>7）<span class="p-text">对于您通过平台发布的涉嫌违法或涉嫌侵犯他人合法权利或违反本协议的信息，我们可予以修改、编辑、删除等，并向您发出相应通知。</span></p>
          <p>8）<span class="p-text">您违反上述行为规范对任意第三方造成损害的，您均应当以自己的名义独立承担所有的法律责任，并应确保我们免于因此产生损失或增加费用。</span></p>
          <p class="bold">5. 众筹项目内容</p>
          <p>1）您确认，您通过平台发起的众筹项目，应严格遵守本协议约定，包含但不限于以下条款：</p>
          <p>&nbsp;&nbsp;&nbsp;a) 众筹项目须是符合平台要求的、具有可执行性的项目，且项目众筹回报须是明确、具体、可衡量的；</p>
          <p>&nbsp;&nbsp;&nbsp;b) 不在众筹项目中为已经通过任何渠道（平台除外）公开发售的商品进行众筹； </p>
          <p>&nbsp;&nbsp;&nbsp;c) 众筹项目的项目回报/众筹回报须为与众筹项目相关的产品，不得是彩票、抽奖相关内容，也不得是股权、债券、分红、利息等具有投资回报性质的内容； </p>
          <p>&nbsp;&nbsp;&nbsp;d) 如您希望发起公益性质的众筹项目，则您须是合法成立的公益组织，或该项目系您与合法成立的公益组织共同发起且您与该公益组织承诺共同完成；</p>
          <p>2）您回报项目支持者的项目众筹回报需符合法律法规规定，由此产生争议的，需由您负责解决并自行承担责任。</p>
          <p class="bold">6. 服务费</p>
          <p>1）发起者收取支持者的众筹服务费，服务费用范围为每笔1%-5%。</p>
          <p class="bold">7. 违约责任</p>
          <p>1）如您涉嫌违反有关法律或者本协议之约定，使我们及/或我们的关联公司遭受任何损失，或受到任何第三方的索赔，或受到任何行政管理部门的处罚，您应当支付违约金并赔偿我们因此遭受的损失及/或发生的费用，包括合理的律师费用、调查取证费用等。</p>
          <p>2）<span class="p-text">如您的行为使我们及/或其关联公司遭受第三人主张权利，我们及/或其关联公司可在对第三人承担金钱给付等义务后，就全部损失向您追偿。</span></p>
          <p>3）除本协议另有约定外，任何一方违反其于本协议项下的陈述、保证或承诺，而使另一方遭受任何诉讼、纠纷、索赔、处罚等的，违约方应负责解决，使另一方发生任何费用、额外责任或遭受经济损失的，应当负责赔偿。如一方发生违约行为，守约方可以书面通知方式要求违约方在指定的时限内停止违约行为，要求其消除影响。如违约方未能按时停止违约行为，则守约方有权立即终止本协议。</p>
          <p class="bold">8. 协议终止及转让</p>
          <p>1）如因您违约，我们可以：</p>
          <p>&nbsp;&nbsp;&nbsp;a) <span class="p-text">解除本协议；</span></p>
          <p>&nbsp;&nbsp;&nbsp;b) <span class="p-text">全部或部分暂停、中止及/或终止履行本协议的义务或提供本协议项下的服务。无论本协议因何原因终止，在协议终止前的行为所导致的任何赔偿和责任，您必须完全且独立地承担责任，且协议的终止不影响本协议第十条的效力。</span></p>
          <p>2）<span class="p-text">我们有权将本协议项下的权利义务转让给第三方，但该等转让不会影响您在本协议项下享有的各项权益。</span></p>
          <p>3）无论本协议因任何原因终止，并不影响本协议终止前已经生效的众筹合同的效力，您均应继续履行在本协议终止前已经生效的众筹合同，或依照众筹合同约定对支持者给予赔偿或补偿。</p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  methods:{
      closeEvent(){
        window.opener=null;
        window.close();
      }
  }
}
</script>

<style lang="scss">

.agreement-container{
  margin-top: 21px;
  border: 1px #e4e4e4 solid;
  background: #fff;
  padding: 0 40px 0 40px;
  p{
    line-height: 30px;
    font-size:14px;
    color:#666;
    word-break: break-all;
  }
  h2{
    padding:60px 0 40px;
    text-align: center;
    font-family:微软雅黑 Bold, 微软雅黑 Regular, 微软雅黑;
    font-weight: 700;
    font-size: 20px;
  }
  .bold{
    font-family:微软雅黑 Bold, 微软雅黑 Regular, 微软雅黑;
    font-weight:700;
    color:#1ABC9C;
    line-height: 76px;
  }

  .p-text {
    text-decoration:underline;
    font-size:14px;
    font-weight:bold;
  }
  .p-t {
    font-size:14px;
    font-weight:bold;
  }

  .p-n {
    text-decoration:underline;
  }
}
.link{
  cursor: pointer;
  .fa-close{
    margin-right: 5px;
    font-size: 16px;
    color: #1ABC9C;
  }
}
</style>
